document.addEventListener(
  "DOMContentLoaded",
  () => {

    const cards =
      document.querySelectorAll(
        "#puff-grid .option-card"
      );

    const hidden =
      document.getElementById(
        "puff3d"
      );

    if (!cards.length || !hidden)
      return;

    cards.forEach(card => {

      card.addEventListener(
        "click",
        () => {

          cards.forEach(c =>
            c.classList.remove("active")
          );

          card.classList.add(
            "active"
          );

          hidden.value =
            card.dataset.puff;

          console.log(
            "PUFF:",
            hidden.value
          );

          document.dispatchEvent(
            new CustomEvent(
              "embroideryUpdated"
            )
          );

        }
      );

    });

  }
);